import { useEffect } from "react";
import loadBackboneApp from "../../../app/load-backbone-app";
import { CRUDView } from "../../../app/components/debug/editors-test";

export default function TestCrud() {
    useEffect(() => {
        const view = new CRUDView();
        loadBackboneApp(view);
    }, []);

    return <></>;
}
